import { Component, Input } from '@angular/core';

@Component({
    selector: 'intro-quiz',
    templateUrl: 'intro-quiz.component.html'
})
export class PreviewQuizIntroComponent {
    @Input('slide') slide;

    constructor() {}
    getCaption(mobile) {
        if( !this.slide ) {
            return '';
        }
        if( mobile && this.slide.imagesMobile.length > 0 ) {
            return this.slide.imagesMobile[0].caption;
        }
        if( this.slide.images.length > 0 ) {
            return this.slide.images[0].caption;
        }
    }
}